/* eslint 'no-useless-concat':'off','no-useless-constructor':'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';

export default class RedirectionConfirmation extends Component {
    constructor(props){
        super(props);
    }
    

    render() {
        var	Action = this.props.Action;
        return (
            <div className="ChangeLimits_Modal">
                <h4 className="Modal_form_title">  {this.props.parentToChildData[0]}</h4>
                <p  className="error_msg">
                {this.props.parentToChildData[1]}
                    </p> 
                  
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button className="btn-gray btn-md"   onClick={() => Action('Cancel')}>{this.props.No}</Button>
                            <Button className="btn-success btn-md"   onClick={() => Action('yes')}> {this.props.Yes} </Button>
                     
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}



